import { render, staticRenderFns } from "./solicitudHUB.vue?vue&type=template&id=7fee6283&scoped=true&"
import script from "./solicitudHUB.vue?vue&type=script&lang=js&"
export * from "./solicitudHUB.vue?vue&type=script&lang=js&"
import style0 from "./solicitudHUB.vue?vue&type=style&index=0&id=7fee6283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee6283",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
